module.exports = __webpack_public_path__ + "img/injury.73bff4e8.png";